import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Form, Input, Button, notification, Tooltip } from 'antd'

import { mapStateToProps, mapDispatchToProps, connect } from '../../reducers/Dispatchers'
import { getEnvironment, request } from '../../utils'
import { HttpMethods } from '../../utils/apiHelper'
import { Environments } from '../../config/environments'
import { ColorsPalette } from '../../config/colors'

const FormItem = Form.Item

class NormalPasswordResetAskForm extends React.Component {
  state = {
    loading: false
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      // The email field is required (rule below): without this guard, values.email is undefined for
      // a field that was never touched → values.email.trim() throws a silent TypeError.
      if (err || !values.email || values.email.trim().length === 0) {
        return
      }

      const email = values.email.trim().toLowerCase()

      this.setState({ loading: true })
      // The backend always answers 200, including for an unknown email or an external account (this
      // prevents enumeration: resetting an external account is its SSO's business). Success is only
      // notified (and the form only left) when the request really goes through.
      request('/auth/reset-password', HttpMethods.POST, { email }, null, { catchError: false }).then((json) => {
        this.setState({ loading: false })

        if (json && json.status === 'error') {
          return
        }

        notification.success({ message: this.props.t('password_reset_ask.email_sent'), placement: 'bottomRight' })
        this.props.onBack()
      }).catch(() => {
        this.setState({ loading: false })
        notification.error({ message: this.props.t('error_handler.unknown_error'), placement: 'bottomRight' })
      })
    })
  }

  render () {
    const { getFieldDecorator } = this.props.form

    return (
      <>
        <Form onSubmit={this.handleSubmit}>
          {this.props.t('What is your email address ? We will send you an email containing a link to reset your password.')}
          <FormItem style={{ marginBottom: '10px' }}>
            {getFieldDecorator('email', {
              rules: [
                { required: true, message: this.props.t('common.email_missing') },
                { type: 'email', message: this.props.t('common.invalid_value') }
              ]
            })(
              <Input prefix={<FontAwesomeIcon icon='at' />} placeholder={this.props.t('common.email_address')} />
            )}
          </FormItem>
          <div className='flex-row'>
            <Tooltip placement='top' title={this.props.t('Back')}>
              <Button type='default' onClick={this.props.onBack}>
                <FontAwesomeIcon icon='arrow-left' />
              </Button>
            </Tooltip>
            <div className='h-spacing' />
            <Button type='primary' htmlType='submit' className='full-width' loading={this.state.loading}>
              <FontAwesomeIcon icon='check' />&nbsp;{this.props.t('Confirm my email address')}
            </Button>
          </div>
        </Form>
        {getEnvironment() !== Environments.PROD && (
          <div className='mt-8 modal-inner-container warning'>
            <div className='flex-row ai-bl'>
              <FontAwesomeIcon
                color={ColorsPalette.WARNING_FONT}
                icon='exclamation-circle'
              />
              <div className='flex-col ai-bl'>
                <span className='pdl-4' style={{ fontSize: '14px' }}>{this.props.t('info_staging.forgotten_password')}</span>
                <a href='https://app.interneo.pro'>
                  <span className='pdl-4' style={{ fontSize: '14px' }}>{this.props.t('info_staging.link_to_prod')}</span>
                </a>
              </div>
            </div>
          </div>
        )}
      </>
    )
  }
}

const PasswordResetAskForm = Form.create()(NormalPasswordResetAskForm)
export default connect(mapStateToProps, mapDispatchToProps)(PasswordResetAskForm)
